import SelectPickerWidget from 'components/Widgets/SelectPicker';

const BaseTypeField = ({ selectItem, setNewSelectItem, item, userList, disabled }) => {
  return (
    <SelectPickerWidget
      selected={selectItem?.value}
      onChange={setNewSelectItem}
      item={item}
      items={userList}
      disabled={disabled}
    />
  );
};

export default BaseTypeField;
